import { useEffect, useState } from 'react';
import ReportListExportSession from './ReportListExportSection';
import { Box, CircularProgress, Link, Alert, Stack, Divider, Grid2 as Grid, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import PageBreadcrumbs from '../../../components/PageBreadcrumbs';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import MiscReportContent from '../../../types/reports/miscReportContent';
import IndependentSpendingReportsTable from './IndependentSpendingReportsTable';
import { useErrorBoundary } from 'react-error-boundary';

const GroupPoliticalSpending = (): JSX.Element => {

  const years: string[] = ["2018 +", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"];
  const [value, setValue] = useState('0');
  const [isLoading, setIsLoading] = useState(true);

  const currentYear = new Date().getFullYear();
  const dropDownYears = Array.from(new Array(currentYear - 2018 + 1), (val, index) => currentYear - index);
  const [reportYear, setReportYear] = useState(new Date().getMonth() === 0 ? currentYear - 1 : currentYear);

  const [reports, setReports] = useState<MiscReportContent[]>([]);
  const [tableRows, setTableRows] = useState<MiscReportContent[]>([]);
  const [organizationDropdown, setOrganizationDropdown] = useState([]);
  const [currentOrganization, setCurrentQOrganization] = useState('All');
  const [summary, setSummary] = useState('No reports found.');

  const { showBoundary } = useErrorBoundary();

  const staticData = [
    {
      value: '1',
      reports: [
        {
          dateFiled: "03/05/2018",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/teamsters252018.pdf",
          organization: "Teamsters Local 25",
          reportingPeriod: "01/01/17 - 12/31/17",
        },
        {
          dateFiled: "03/12/2018",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/aflcio2018last.pdf",
          organization: "Massachusetts AFL-CIO",
          reportingPeriod: "12/06/17 - 12/31/17",
        },
        {
          dateFiled: "01/25/2018",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/32bjye2017.pdf",
          organization: "32 BJ United American Dream Fund",
          reportingPeriod: "07/01/17 - 12/31/17",
        },
        {
          dateFiled: "01/24/2018",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/ernaye2017.pdf",
          organization: "Education Reform Now Advocacy",
          reportingPeriod: "07/01/17 - 12/31/17",
        },
        {
          dateFiled: "01/24/2018",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/ernamy2017.pdf",
          organization: "Education Reform Now Advocacy",
          reportingPeriod: "01/01/17 - 06/30/17",
        },
        {
          dateFiled: "01/22/2018",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/nageye2017.pdf",
          organization: "NAGE / SEIU Local 5000",
          reportingPeriod: "01/01/17 - 12/31/17",
        },
        {
          dateFiled: "01/10/2018",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/mtaye2017.pdf",
          organization: "Massachusetts Teachers Association",
          reportingPeriod: "07/01/17 - 12/31/17",
        },
        {
          dateFiled: "07/13/2017",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/32bj2017.pdf",
          organization: "32 BJ United American Dream Fund",
          reportingPeriod: "01/01/17 - 06/30/17",
        },
        {
          dateFiled: "07/24/2017",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/erna2017.pdf",
          organization: "Education Reform Now Advocacy",
          reportingPeriod: "01/01/17 - 06/30/17",
        },
        {
          dateFiled: "08/22/2017",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/mta2017.pdf",
          organization: "Mass. Teachers Association",
          reportingPeriod: "01/01/17 - 07/31/17",
        },
        {
          dateFiled: "11/27/2017",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/massaflcionov2017.pdf",
          organization: "Mass. AFL-CIO",
          reportingPeriod: "01/01/17 - 11/16/17",
        },
        {
          dateFiled: "12/11/2017",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/massaflcio2017.pdf",
          organization: "Mass. AFL-CIO",
          reportingPeriod: "01/01/17 - 12/06/17",
        },
      ]
    },

    {
      value: '2',
      reports: [
        {
          dateFiled: "08/22/2017",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/mta2016.pdf",
          organization: "Mass. Teachers Association",
          reportingPeriod: "01/01/16 - 12/31/16",
        },
        {
          dateFiled: "01/19/2017",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/csj2.pdf",
          organization: "Coalition for Social Justice",
          reportingPeriod: "10/23/16 - 12/31/16",
        },
        {
          dateFiled: "01/16/2017",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/32bj2.pdf",
          organization: "32BJ United American Dream Fund",
          reportingPeriod: "10/22/16 - 12/31/16",
        },
        {
          dateFiled: "01/17/2017",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/erna2.pdf",
          organization: "Education Reform Now Advocacy Inc.",
          reportingPeriod: "10/23/16 - 12/31/16",
        },
        {
          dateFiled: "01/17/2017",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/50001",
          organization: "NAGE/SEIU Local 5000",
          reportingPeriod: "01/01/16 - 12/31/16",
        },
        {
          dateFiled: "11/01/2016",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/32jb1.pdf",
          organization: "32BJ United American Dream Fund",
          reportingPeriod: "08/22/16 - 10/21/16",
        },
        {
          dateFiled: "10/31/2016",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/erna1.pdf",
          organization: "Education Reform Now Advocacy",
          reportingPeriod: "08/22/16 - 10/22/16",
        },
        {
          dateFiled: "10/31/2016",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/csj1.pdf",
          organization: "Coalition for Social Justice",
          reportingPeriod: "01/01/16 - 10/22/16",
        },
        {
          dateFiled: "11/01/2016",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/32bj2016pe.pdf",
          organization: "32BJ United American Dream Fund",
          reportingPeriod: "08/22/16 - 10/21/16",
        },
        {
          dateFiled: "10/31/2016",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/educationreformpe2016.pdf",
          organization: "Education Reform Now Advocacy Inc.",
          reportingPeriod: "08/22/16 - 10/22/16",
        },
        {
          dateFiled: "10/31/2016",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/socialjusticepe2016.pdf",
          organization: "Coalition for Social Justice",
          reportingPeriod: "01/01/16 - 10/22/16",
        },
        {
          dateFiled: "08/29/2016",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/edreformpp2016.pdf",
          organization: "Education Reform Now Advocacy Inc.",
          reportingPeriod: "02/13/16 - 08/21/16",
        },
        {
          dateFiled: "08/25/2016",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/32bjpp2016.pdf",
          organization: "32BJ United American Dream Fund",
          reportingPeriod: "07/01/16 - 08/21/16",
        },
        {
          dateFiled: "10/31/2016",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/educationreformpe2016.pdf",
          organization: "Education Reform Now",
          reportingPeriod: "07/01/16 - 08/21/16",
        },
        {
          dateFiled: "10/31/2016",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/socialjusticepe2016.pdf",
          organization: "Coalition for Social Justice",
          reportingPeriod: "07/01/16 - 08/21/16",
        },
        {
          dateFiled: "10/31/2016",
          reportUrl: "htp://files.ocpf.us/pdf/reports/111s/32bj2016pe.pdf",
          organization: "32BJ United American Dream Fund",
          reportingPeriod: "07/01/16 - 08/21/16",
        },
      ]
    },

    {
      value: '3',
      reports: [
        {
          dateFiled: "01/22/2015",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/aft15ye.pdf",
          organization: "American Federation of Teachers Solidarity (AFT Solidarity)",
          reportingPeriod: "01/01/15 - 12/31/15",
        },
        {
          dateFiled: "07/21/2015",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/32bjdream15ye.pdf",
          organization: "32BJ United American Dream Fund",
          reportingPeriod: "01/01/15 - 06/30/15",
        },
        {
          dateFiled: "01/20/2015",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/nage500015ye.pdf",
          organization: "NAGE / SEIU Local 5000",
          reportingPeriod: "01/01/15 - 12/31/15",
        },
        {
          dateFiled: "01/20/2015",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/nage29215ye.pdf",
          organization: "NAGE Local 292",
          reportingPeriod: "01/01/15 - 12/31/15",
        },
        {
          dateFiled: "01/20/2015",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/nage28215ye.pdf",
          organization: "NAGE Local 282",
          reportingPeriod: "01/01/15 - 12/31/15",
        },
        {
          dateFiled: "01/20/2015",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/nage20715ye.pdf",
          organization: "NAGE Local 207",
          reportingPeriod: "01/01/15 - 12/31/15",
        },
        {
          dateFiled: "01/20/2015",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/nage30815ye.pdf",
          organization: "NAGE Local 308",
          reportingPeriod: "01/01/15 - 12/31/15",
        },
        {
          dateFiled: "01/19/2015",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/laborers15ye.pdf",
          organization: "Laborers' International Union of North America - Education Account",
          reportingPeriod: "01/01/15 - 12/31/15",
        },
        {
          dateFiled: "01/20/2015",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/afscme15ye.pdf",
          organization: "American Federation of State, County and Municipal Employees",
          reportingPeriod: "01/01/15 - 12/31/15",
        },
        {
          dateFiled: "01/19/2015",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/iaff15ye.pdf",
          organization: "International Association of Fire Fighters",
          reportingPeriod: "01/01/15 - 12/31/15",
        },
      ]
    },

    {
      value: '4',
      reports: [
        {
          dateFiled: "12/09/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/cppa2014.pdf",
          organization: "Chinese Progressive Political Action",
          reportingPeriod: "01/01/2014 - 12/31/2014",
        },
        {
          dateFiled: "12/03/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/afscme2014december.pdf",
          organization: "American Federation of State, County and Municipal Employees",
          reportingPeriod: "10/18/14 - 11/24/2014",
        },
        {
          dateFiled: "11/05/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/32bj2014.pdf",
          organization: "32BJ United American Dream Fund",
          reportingPeriod: "01/01/14 - 10/31/14",
        },
        {
          dateFiled: "10/28/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/afscmePE14.pdf",
          organization: "American Federation of State, County and Municipal Employees",
          reportingPeriod: "08/23/14 - 10/17/14",
        },
        {
          dateFiled: "10/27/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/seiuPE14.pdf",
          organization: "NAGE / SEIU Local 5000",
          reportingPeriod: "01/01/14 - 10/17/14",
        },
        {
          dateFiled: "10/27/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/308PE14.pdf",
          organization: "NAGE Local 308",
          reportingPeriod: "01/01/14 - 10/17/14",
        },
        {
          dateFiled: "10/27/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/292PE14.pdf",
          organization: "NAGE Local 292",
          reportingPeriod: "01/01/14 - 10/17/14",
        },
        {
          dateFiled: "10/27/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/nagePE14.pdf",
          organization: "NAGE Local 282",
          reportingPeriod: "01/01/14 - 10/17/14",
        },
        {
          dateFiled: "10/27/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/207PE14.pdf",
          organization: "NAGE Local 207",
          reportingPeriod: "01/01/14 - 10/17/14",
        },
        {
          dateFiled: "10/24/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/unitePE14.pdf",
          organization: "UNITE HERE TIP State and Local Fund",
          reportingPeriod: "08/23/14 - 10/17/14",
        },
        {
          dateFiled: "09/04/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/111_509_2014.pdf",
          organization: "SEIU Local 509",
          reportingPeriod: "01/01/14 - 09/02/14",
        },
        {
          dateFiled: "09/02/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/111_afscme_2014.pdf",
          organization: "American Federation of State, County and Municipal Employees",
          reportingPeriod: "01/01/14 - 08/22/2014",
        },
        {
          dateFiled: "08/28/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/111_unite_2014.pdf",
          organization: "UNITE HERE TIP State and Local Fund",
          reportingPeriod: "01/01/14 - 08/22/14",
        },
      ]
    },
    {
      value: '5',
      reports: [
        {
          dateFiled: "02/04/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/99.pdf",
          organization: "The Ninety Nine Percent",
          reportingPeriod: "01/01/2013 - 12/31/2013",
        },
        {
          dateFiled: "01/21/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/mta2013.pdf",
          organization: "Mass. Teachers Association",
          reportingPeriod: "01/01/2013 - 12/31/2013",
        },
        {
          dateFiled: "01/23/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/iaff2013.pdf",
          organization: "International Association of Fire Fighters",
          reportingPeriod: "10/19/13 - 12/31/13",
        },
        {
          dateFiled: "01/17/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/afscme.pdf",
          organization: "American Federation of State, County and Municipal Employees",
          reportingPeriod: "11/26/13 - 12/31/13",
        },
        {
          dateFiled: "01/17/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/seiu111ye.pdf",
          organization: "SEIU/NAGE Local 5000",
          reportingPeriod: "01/01/13 - 12/31/13",
        },
        {
          dateFiled: "01/17/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/tip111ye.pdf",
          organization: "UNITE HERE TIP State and Local Fund",
          reportingPeriod: "01/01/13 - 12/31/13",
        },
        {
          dateFiled: "01/15/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/wwa111ye.pdf",
          organization: "Working for Working Americans",
          reportingPeriod: "10/19/13 - 12/31/13",
        },
        {
          dateFiled: "01/15/2014",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/liu111ye.pdf",
          organization: "Laborers' International Union of North America Education Account",
          reportingPeriod: "10/19/13 - 12/31/13",
        },
        {
          dateFiled: "12/23/2013",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/chinesepro.pdf",
          organization: "Chinese Progressive Political Action",
          reportingPeriod: "01/01/2013 - 12/31/2013",
        },
        {
          dateFiled: "11/01/2013",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/111_1.pdf",
          organization: "Massachusetts Nurses Association",
          reportingPeriod: "01/01/13 - 12/31/13",
        },
        {
          dateFiled: "10/30/2013",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/111_5.pdf",
          organization: "Local 32BJ SEIU NY/NJ American Dream Fund",
          reportingPeriod: "07/08/13 - 10/28/13",
        },
        {
          dateFiled: "10/28/2013",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/111_4.pdf",
          organization: "Laborers' International Union of North America Education Account",
          reportingPeriod: "09/07/13 - 10/18/13",
        },
        {
          dateFiled: "10/28/2013",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/111_3.pdf",
          organization: "International Association of Fire Fighters",
          reportingPeriod: "09/07/13 - 10/18/13",
        },
        {
          dateFiled: "10/28/2013",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/111_2.pdf",
          organization: "American Federation of State, County and Municipal Employees",
          reportingPeriod: "01/01/13 - 10/18/13",
        },
        {
          dateFiled: "09/24/2013",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/iaff_2013.pdf",
          organization: "International Association of Fire Fighters",
          reportingPeriod: "01/01/13 - 09/06/13",
        },
        {
          dateFiled: "09/10/2013",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/iaff_2013.pdf",
          organization: "International Association of Fire Fighters",
          reportingPeriod: "01/01/13 - 09/06/13",
        },
        {
          dateFiled: "07/10/2013",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/seiu_2013_my.pdf",
          organization: "SEIU Local 509",
          reportingPeriod: "01/01/13 - 06/30/13",
        },
        {
          dateFiled: "07/19/2013",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/seiunage_2013_my.pdf",
          organization: "SEIU/NAGE Local 5000",
          reportingPeriod: "01/01/13 - 06/30/13",
        },
      ]
    },
    {
      value: '6',
      reports: [
        {
          dateFiled: "1/22/2013",
          organization: "Mass. Teachers Association",
          reportingPeriod: "10/20/2012 - 12/31/2012",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/mta_2012_final.pdf",
        },
        {
          dateFiled: "1/28/2013",
          organization: "SEIU/NAGE Local 5000",
          reportingPeriod: "10/20/2012 - 12/31/2012",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/nage_2012.pdf",
        },
        {
          dateFiled: "1/15/2013",
          organization: "SEIU Local 509",
          reportingPeriod: "10/20/2012 - 12/31/2012",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/seiu_ye_2012.pdf",
        },
        {
          dateFiled: "10/30/2012",
          organization: "Mass. Teachers Association",
          reportingPeriod: "1/1/12 - 10/19/12",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/mta_2012.pdf",
        },
        {
          dateFiled: "10/26/2012",
          organization: "SEIU/NAGE Local 5000",
          reportingPeriod: "8/20/12 - 10/19/12",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/seiu_2012_pre_election.pdf",
        },
        {
          dateFiled: "10/25/2012",
          organization: "SEIU Local 509",
          reportingPeriod: "8/20/12 - 10/19/12",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/seiu_2012_509.pdf",
        },
        {
          dateFiled: "8/28/2012",
          organization: "SEIU/NAGE Local 5000",
          reportingPeriod: "1/1/12 - 8/19/12",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/seiu5000_2012.pdf",
        },
      ]
    },
    {
      value: '7',
      reports: [
        {
          "dateFiled": "9/4/2012",
          "organization": "SEIU Local 509",
          "reportingPeriod": "1/1/11 - 12/31/11",
          "reportUrl": "https://ocpf2.blob.core.windows.net/pdf/reports/111s/seiu509_2011.pdf"
        },
        {
          "dateFiled": "1/20/2012",
          "organization": "Massachusetts Teachers Association",
          "reportingPeriod": "1/1/11 - 12/31/11",
          "reportUrl": "https://ocpf2.blob.core.windows.net/pdf/reports/111s/teachers_2011.pdf"
        },
        {
          "dateFiled": "1/20/2012",
          "organization": "Massachusetts Nurses Association",
          "reportingPeriod": "1/1/11 - 12/31/11",
          "reportUrl": "https://ocpf2.blob.core.windows.net/pdf/reports/111s/nurses_2011.pdf"
        },
        {
          "dateFiled": "1/19/2012",
          "organization": "NAGE Local R1-207",
          "reportingPeriod": "1/1/11 - 12/31/11",
          "reportUrl": "https://ocpf2.blob.core.windows.net/pdf/reports/111s/207_2011.pdf"
        },
        {
          "dateFiled": "1/19/2012",
          "organization": "NAGE Local R1-282",
          "reportingPeriod": "1/1/11 - 12/31/11",
          "reportUrl": "https://ocpf2.blob.core.windows.net/pdf/reports/111s/282_2011.pdf"
        },
        {
          "dateFiled": "1/18/2012",
          "organization": "UNITE HERE TIP",
          "reportingPeriod": "1/1/11 - 12/31/11",
          "reportUrl": "https://ocpf2.blob.core.windows.net/pdf/reports/111s/unite_2011.pdf"
        },
        {
          "dateFiled": "1/17/2012",
          "organization": "SEIU/NAGE Local 5000",
          "reportingPeriod": "1/1/11 - 12/31/11",
          "reportUrl": "https://ocpf2.blob.core.windows.net/pdf/reports/111s/seiu_2011.pdf"
        }
      ]
    },
    {
      value: '8',
      reports: [
        {
          dateFiled: "9/4/2012",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/seiu509_2010.pdf",
          organization: "SEIU Local 509",
          reportingPeriod: "1/1/10 - 12/31/10"
        },
        {
          dateFiled: "1/20/2011",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/teachers_2010.pdf",
          organization: "Mass. Teachers Association",
          reportingPeriod: "1/1/10 - 12/31/10"
        },
        {
          dateFiled: "1/19/2011",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/nagelocal_2010.pdf",
          organization: "NAGE Local R1 - 282",
          reportingPeriod: "1/1/10 - 12/31/10"
        },
        {
          dateFiled: "1/13/2011",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/nage_2010.pdf",
          organization: "SEIU/NAGE Local 5000",
          reportingPeriod: "1/1/10 - 12/31/10"
        },
        {
          dateFiled: "1/13/2011",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/unitehere_20103.pdf",
          organization: "Unite Here TIP",
          reportingPeriod: "10/16/10 - 12/31/10"
        },
        {
          dateFiled: "10/20/2010",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/unitehere_20102.pdf",
          organization: "Unite Here TIP",
          reportingPeriod: "08/28/10 - 10/15/10"
        },
        {
          dateFiled: "09/03/2010",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/unitehere_2010.pdf",
          organization: "Unite Here TIP",
          reportingPeriod: "01/01/10 - 08/27/10"
        }
      ]
    },
    {
      value: '9',
      reports: [
        {
          dateFiled: "01/20/2010",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/seiu_2009.pdf",
          organization: "SEIU/NAGE Local 5000",
          reportingPeriod: "01/01/09 - 12/31/09"
        },
        {
          dateFiled: "01/20/2010",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/seiu_2009.pdf",
          organization: "Massachusetts Teachers Association",
          reportingPeriod: "01/01/09 - 12/31/09"
        }
      ]
    },
    {
      value: '10',
      reports: [
        {
          dateFiled: "02/13/2009",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/02_13_09_seiu_1199.pdf",
          organization: "1199 SEIU",
          reportingPeriod: "01/01/08 - 12/31/08"
        },
        {
          dateFiled: "01/26/2009",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/01_26_09_mna_08.pdf",
          organization: "Massachusetts Nurses Association",
          reportingPeriod: "01/01/08 - 12/31/08"
        },
        {
          dateFiled: "01/20/2009",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/01_20_09_mta_08.pdf",
          organization: "Massachusetts Teachers Association",
          reportingPeriod: "01/01/08 - 12/31/08"
        },
        {
          dateFiled: "01/16/2009",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/01_16_09_seiu_08.pdf",
          organization: "SEIU/NAGE Local 5000",
          reportingPeriod: "01/01/08 - 12/31/08"
        }
      ]
    },
    {
      value: '11',
      reports: [
        {
          dateFiled: "05/02/2008",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/05_02_08_seiu_ny_07.pdf",
          organization: "1199 SEIU New York State Political Action Fund",
          reportingPeriod: "01/01/07 - 12/31/07"
        },
        {
          dateFiled: "02/19/2008",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/02_19_08_seiu_07.pdf",
          organization: "1199 SEIU United Healthcare Workers East",
          reportingPeriod: "01/01/07 - 12/31/07"
        },
        {
          dateFiled: "01/22/2008",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/01_22_08_mta_07.pdf",
          organization: "Mass. Teachers Association",
          reportingPeriod: "01/01/07 - 12/31/07"
        },
        {
          dateFiled: "01/22/2008",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/01_22_08_seiu_nage_07.pdf",
          organization: "SEIU / NAGE Local 5000",
          reportingPeriod: "11/01/07 - 12/31/07"
        },
        {
          dateFiled: "01/10/2008",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/01_10_08_mna_07.pdf",
          organization: "Mass. Nurses Association",
          reportingPeriod: "01/01/07 - 12/31/07"
        }
      ]
    },
    {
      value: '12',
      reports: [
        {
          dateFiled: "04/20/2007",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/04_20_07_mna_06.pdf",
          organization: "Mass. Nurses Association",
          reportingPeriod: "01/01/06 - 12/31/06"
        },
        {
          dateFiled: "01/22/2007",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/01_22_07_mta_06.pdf",
          organization: "Mass. Teachers Association",
          reportingPeriod: "10/21/06 - 12/31/06"
        },
        {
          dateFiled: "01/19/2007",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/01_19_07_seiu_nage_06.pdf",
          organization: "SEIU / NAGE Local 5000",
          reportingPeriod: "01/01/06 - 12/31/06"
        }
      ]
    },
    {
      value: '13',
      reports: [
        {
          dateFiled: "04/02/2007",
          reportUrl: "https://ocpf2.blob.core.windows.net/pdf/reports/111s/04_02_07_seiu_05.pdf",
          organization: "1199 SEIU United Healthcare Workers East",
          reportingPeriod: "01/01/05 - 12/31/05"
        }
      ]
    }


  ]


  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const updateReportYear = (event: any) => {
    setReportYear(event.target.value);

  };

  const updateOrganization = (event: any) => {
    setCurrentQOrganization(event.target.value);
  }

  const getOrganizationDropdown = async () => {
    try {
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/miscreports/entities/${reportYear}?reportType=PSR`)
        .then(result => {
          if (!result.ok) {
            showBoundary(new Error('Failed to get the Independent Expenditure filers.'));
          }
          return result.json();
        })
        .then(result => {
          setOrganizationDropdown(result);
        });
    } catch (error) {
      console.error('Uncaught Error:', error);
    }
  }

  const getSummary = async () => {
    try {
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/miscreports/reports/summary/${reportYear}?reportTypeDescription=PSR`)
        .then(result => {
          if (!result.ok) {
            showBoundary(new Error('Failed to get PSR reports summary.'));
          }
          return result.json();
        })
        .then(result => {
          let count = result.count;
          if (count === 0) {
            setSummary("No reports found.");
            return;
          }
          else {
            setSummary(`Viewing 1 through ${count} of ${count} reports, ${result.totalDisplay}`);
          }


        });
    } catch (error) {
      console.error('Uncaught Error:', error);
    }
  }

  const getGroupPoliticalSpendingReports = async () => {
    try {
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/miscreports/reports/${reportYear}?reportTypeDescription=PSR`)
        .then(result => {
          if (!result.ok) {
            showBoundary(new Error('Failed to get PSRs.'));
          }
          return result.json();
        })
        .then(result => {
          setReports(result);
          setTableRows(result);
          getSummary();
          setIsLoading(false);
        });
    } catch (error) {
      console.error('Uncaught Error:', error);
    }
  }

  const handleFilterChange = () => {

    const filtered = reports?.filter((row: MiscReportContent) => {

      const matchesOrganization = currentOrganization === 'All' || row.filingEntity.includes(currentOrganization);

      return matchesOrganization;
    });
    setTableRows(filtered);
    if (filtered) {
      filtered.length > 0 ? setSummary(`Viewing 1 through ${filtered.length} of ${reports?.length} reports`) : setSummary("No reports found.");
    } else {
      setSummary("No reports found.");
    }


  };

  useEffect(() => {
    getGroupPoliticalSpendingReports();
    getOrganizationDropdown();
  }, [reportYear]);

  useEffect(() => {
    handleFilterChange();
  }, [currentOrganization]);

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
          variant="h5"
          align={'left'}
          data-aos={'fade-up'}
          sx={{
            fontWeight: 700,
          }}
          paddingTop={3}
          gutterBottom
          marginBottom={2}
        >
          Political Spending Reports of Other Groups and Associations
        </Typography>
        <Divider />
        <Grid container marginTop={3}>
          <Grid size={12}>
            <Typography marginBottom={1} variant='h6' fontWeight={'bold'}>What is a CPF Form 111 Report?</Typography>
            <Typography marginBottom={1} sx={{ textIndent: 10 }} component={'p'} variant='body1'>When an organization has made political contributions or expenditures or incurred liabilities to support candidates or political committees in excess of the "incidental threshold" set out in OCPF Interpretive Bulletin <Link href='https://ocpf2.blob.core.windows.net/pdf/legaldocs/IB-88-01.pdf' target='_blank'>IB-88-01</Link> a duly qualified officer of the organization must file a CPF Form 111: Report of Association or Other Group Making Contributions to or Expenditures on Behalf of Candidates, PACs, or Party Committees.</Typography>
            <Typography marginBottom={1} sx={{ textIndent: 10 }} component={'p'} variant='body1'>The report must disclose all contributions and expenditures made and liabilities incurred during the calendar year.</Typography>
            <Typography marginBottom={1} sx={{ textIndent: 10 }} component={'p'} variant='body1'>The obligation to file a report continues for each year thereafter until the year after a year in which the incidental threshold is not reached.</Typography>
          </Grid>
        </Grid>

        <TabContext value={value}>
          <Box sx={{ marginTop: 2, borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example" variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
              {years.map((year, index) => (
                <Tab label={year} value={index.toString()} />
              ))}

            </TabList>
          </Box>
          <TabPanel value="0">
            <Grid container marginBottom={2} marginTop={3}>

              <Grid size={{ xs: 12, md: 10 }}>
                <Stack direction={"row"} spacing={1}
                  sx={{ mb: 1 }}
                >

                  <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <InputLabel id="year-id">Year</InputLabel>
                    <Select
                      labelId="year-id"
                      id="year-select"
                      aria-labelledby='year-id'
                      sx={{ fontSize: 'smaller' }}
                      label="Report Year"
                      value={reportYear}
                      onChange={updateReportYear}
                    >
                      {
                        dropDownYears.map((year) =>
                          <MenuItem value={year} key={year} >{year}</MenuItem>
                        )
                      }
                    </Select>
                  </FormControl>




                  <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <InputLabel id="filer-id">Filer</InputLabel>
                    <Select
                      labelId="filer-id"
                      id="filer-select"
                      aria-labelledby='filer-id'
                      sx={{ fontSize: 'smaller' }}
                      label="Type"
                      value={currentOrganization}
                      onChange={updateOrganization}
                    >
                      <MenuItem value='All' key='All' >All</MenuItem>
                      {

                        organizationDropdown.map((organization) =>
                          <MenuItem value={organization} key={organization} >{organization}</MenuItem>
                        )
                      }

                    </Select>
                  </FormControl>


                </Stack>

              </Grid>

                <Grid size={{ xs: 12, md: 2 }}>
                {/* <ReportListExportSession></ReportListExportSession> */}

              </Grid>


              <Grid size={12}>
                <Alert icon={false} severity="info"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    '.MuiAlert-message': {
                      padding: '4px',
                    }
                  }}
                >
                  {summary}
                </Alert>
              </Grid>
            </Grid>
            <IndependentSpendingReportsTable tableRows={tableRows} type='psr'></IndependentSpendingReportsTable>
          </TabPanel>
          {
            staticData.map((tabInfo) => {
              return (
                <TabPanel value={tabInfo.value}>
                  <TableContainer>
                    <Table>
                      <TableHead >
                        <TableRow>
                          <TableCell><b>Date Filed</b></TableCell>
                          <TableCell><b>Name of Group / Organization</b></TableCell>
                          <TableCell><b>Reporting Period</b></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tabInfo.reports.map((report) => (
                          <TableRow key={report.dateFiled}>
                            <TableCell><Link href={report.reportUrl} target='_blank'>{report.dateFiled}</Link></TableCell>
                            <TableCell>{report.organization}</TableCell>
                            <TableCell>{report.reportingPeriod}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                </TabPanel>
              );
            })
          }
        </TabContext>
        <CircularProgress
          aria-label='Loading'
          size={50}
          className={isLoading ? "" : "hidden"}
          sx={{
            position: "fixed",
            left: "50%",
            top: "20%",
            transform: "translate(-50%, -50%)",
            zIndex: 2
          }}
        />
      </Container>
    </Main>
  );
};

export default GroupPoliticalSpending;